import PropTypes from 'prop-types'

import { ConfirmationDialog } from '@collaborate-health/uikit'

const DeleteReportDependentModuleConfirmationDialog = ({ open, onClose, onSubmit }) => {
  return (
    <ConfirmationDialog
      isOpen={open}
      onCloseDialog={onClose}
      onSubmit={onSubmit}
      title='Are you sure you want to delete this dependent report?'
      submitButtonText='Yes'
      cancelButtonText='No'
    />
  )
}

DeleteReportDependentModuleConfirmationDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
}

export default DeleteReportDependentModuleConfirmationDialog
